import * as constants from './constants';
import * as Types from './types';

export const warnNoTranslation = (tKey: string): void => window.console.warn(`NO TRANSLATION: ${tKey}`);

export const warnUnknownKey = (tKey: string): void => window.console.error(`NO DEFAULT TRANSLATION / UNKNOWN KEY: ${tKey}`);

export const validateTranslations = ({
    translations,
    defaultTranslations
}: {
    translations: Record<string, string>;
    defaultTranslations: Record<string, string>;
}): void => {
    const keys = Object.keys(translations);

    Object.keys(defaultTranslations).forEach((defKey) => {
        if (!keys.includes(defKey)) {
            warnNoTranslation(defKey);
        }
    });
};

export const getTranslation = ({
    tKey,
    i18n,
    defaultValue = tKey,
    replacers
}: {
    tKey: string;
    i18n: Types.II18nState;
    defaultValue?: Types.TTranslationStringifyValue;
    replacers?: Types.TTranslationReplacers;
}): string => {
    if (!tKey) {
        return '';
    }

    const { translations, defaultTranslations, showTranslationKeys } = i18n;
    const translation: string | undefined = translations[tKey];
    const defaultTranslation: string | undefined = defaultTranslations[tKey];

    if (showTranslationKeys) {
        if (translation == null) {
            warnNoTranslation(tKey);

            if (defaultTranslation == null) {
                warnUnknownKey(tKey);
            }
        }

        return [
            tKey,
            defaultValue !== tKey && `(${defaultValue})`,
            replacers && `[${replacers.join(', ')}]`
        ].filter(Boolean).join(' ');
    }

    if (translation != null) {
        return translation;
    }

    if (defaultTranslation != null) {
        return defaultTranslation;
    }

    return defaultValue.toString();
};

export const formatReplacers = (str: string, ...params: Types.TTranslationReplacers): string =>
    str.replace(/{(\d+)}/g, (_, i) => params[i] !== undefined ? params[i].toString() : '');

export const getTranslationKeyValue = ({
    translationKey,
    prefix,
    args,
    i18n
}: {
    translationKey: string;
    prefix: string;
    args: Types.TTranslationArguments;
    i18n: Types.II18nState;
}): string => {
    let replacers: Types.TTranslationReplacers | undefined;
    let defaultValue: Types.TTranslationStringifyValue | undefined;

    if (Array.isArray(args[0])) {
        [replacers, defaultValue] = args;
    } else {
        [defaultValue] = args;
    }

    const tKey = translationKey.startsWith(constants.TK_PREFIX)
        ? translationKey
        : prefix + translationKey;
    const tValue = getTranslation({ tKey, i18n, defaultValue, replacers });

    return replacers ? formatReplacers(tValue, ...replacers) : tValue;
};
